import { render, staticRenderFns } from "./SidebarStatusPermohonan.vue?vue&type=template&id=738a21b0&"
import script from "./SidebarStatusPermohonan.vue?vue&type=script&lang=js&"
export * from "./SidebarStatusPermohonan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports